import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { SiteHeader } from "@/components/Chrome";
import Home from "@/pages/Home";
import Explore from "@/pages/Explore";
import MyProperties from "@/pages/MyProperties";
import Workspace from "@/pages/Workspace";
import VisionPage from "@/pages/VisionPage";
import Contribute from "@/pages/Contribute";
import Proposal from "@/pages/Proposal";
import OwnerInvite from "@/pages/OwnerInvite";
import OwnerView from "@/pages/OwnerView";
import DemoPage from "@/pages/DemoPage";
import { AuthDialog } from "@/components/AuthDialog";
import { GoogleReturn } from "@/components/GoogleReturn";
import "@/lib/auth";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth", block: "center" }), 120);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollManager />
      <SiteHeader />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/properties" element={<MyProperties />} />
        <Route path="/my-properties" element={<MyProperties />} />
        <Route path="/p/:id" element={<Workspace />} />
        <Route path="/v/:id" element={<VisionPage />} />
        <Route path="/c/:token" element={<Contribute />} />
        <Route path="/m/:id" element={<Proposal />} />
        <Route path="/owner" element={<OwnerView />} />
        <Route path="/owner/:token" element={<OwnerInvite />} />
        <Route path="/demo" element={<DemoPage />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <AuthDialog />
      <GoogleReturn />
      <Toaster position="bottom-center" toastOptions={{ style: { background: "#1f1c19", color: "#f6f2ea", border: "none", borderRadius: 999 } }} />
    </BrowserRouter>
  );
}

export default App;
